import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ForestSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ForestSVG;
